import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [err, setErr] = useState(null);
  const hasRun = React.useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user); // CRITICAL: populate auth context so bottom-nav links don't bounce back to /
        window.history.replaceState(null, "", window.location.pathname);
        const pendingToken = sessionStorage.getItem("pending_invite_token");
        if (pendingToken) {
          navigate(`/join/${pendingToken}`, { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (e) {
        setErr(e?.response?.data?.detail || "Login failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-100">
      <div className="text-center">
        <div className="label-eyebrow mb-2">Proximity</div>
        <div className="font-display text-2xl font-bold">
          {err ? "Sign-in failed" : "Establishing secure link…"}
        </div>
        {err && <div className="mt-3 text-sm text-red-400">{err}</div>}
      </div>
    </div>
  );
}
